var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/arrow-left"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.7619 25.0935C12.5085 25.0935 12.2552 25.0002 12.0552 24.8002L3.96187 16.7068C3.57521 16.3202 3.57521 15.6802 3.96187 15.2935L12.0552 7.20016C12.4419 6.81349 13.0819 6.81349 13.4685 7.20016C13.8552 7.58682 13.8552 8.22682 13.4685 8.61349L6.08187 16.0002L13.4685 23.3868C13.8552 23.7735 13.8552 24.4135 13.4685 24.8002C13.2819 25.0002 13.0152 25.0935 12.7619 25.0935Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M27.3306 17H4.89062C4.34396 17 3.89062 16.5467 3.89062 16C3.89062 15.4533 4.34396 15 4.89062 15H27.3306C27.8773 15 28.3306 15.4533 28.3306 16C28.3306 16.5467 27.8773 17 27.3306 17Z",
    fill: "#333333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft2);
export default __webpack_public_path__ + "static/media/arrow_left2.a115a3fcfdcad10356ace3b6c65cd47c.svg";
export { ForwardRef as ReactComponent };